import {
  AppBar,
  Button,
  Container,
  Dialog,
  Grid,
  IconButton,
  LinearProgress,
  Skeleton,
  Slide,
  Toolbar,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import { Box } from "@mui/system";
import React, { useCallback, useEffect, useState } from "react";
import InformasiKejadian from "./Component/InformasiKejadian";
import SaveIcon from "@mui/icons-material/Save";
import KemungkinanPenyebab from "./Component/KemungkinanPenyebab";
import HeaderUser from "./Component/HeaderUser";
import EstimateImpact from "./Component/EstimateImpact";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import FooterReport from "./Component/FooterReport";
import ApiService from "../../services/ApiService";
import LanjutanImpact from "./Component/LanjutanImpact";
import fieldStyles from "../../styles/fieldStyles";
import { momentDateToDB, momentTimeToDB } from "../../utils/dateTime";
import { LoadingButton } from "@mui/lab";
import DialogCustom from "../../components/DialogCustom";
import SnackbarCustom from "../../components/SnackbarCustom";
import LKPToPDF from "../../components/Dashboard/LKPToPDF";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import EstimateImpactRevamp from "./Component/EstimateImpactRevamp";
import { debounce } from "lodash";
import ListReviewer from "./Component/ListReviewer";
import ListApproval from "./Component/ListApproval";
import html2pdf from "html2pdf.js";
import InformasiTembusan from "./Component/InformasiTembusan";
import boxStyles from "../../styles/boxStyles";

const potensiTingkatKeparahanItem = [
  { value: "1", name: "Insignificant" },
  { value: "2", name: "Minor" },
  { value: "3", name: "Moderate" },
  { value: "4", name: "Significant" },
  { value: "5", name: "Catastrophic" },
];

function LinearProgressWithLabel(props) {
  return (
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Box sx={{ width: "100%", mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  );
}

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const EditLKP = () => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [showRecordable, setShowRecordable] = useState(0);
  const [inputFields, setInputFields] = useState({
    //// Header User
    idLkp: 0,
    noLkp: "",
    idUnitBisnis: null,
    idRegional: null,
    idLokasi: null,
    namaLokasi: "",
    tglKejadian: "",
    waktuKejadian: "",
    tglLaporan: "",
    judulLaporan: "",
    statusLkp: "",
    perusahaanTerlibat: "",
    documentPosition: "",
    listApproval: [],

    //// Informasi Kejadian
    deskripsiSingkat: "",
    locationTagLong: 0,
    locationTagLat: 0,
    namaLokasiOnMap: "",
    isHipo: true,
    listAllKategoriInsiden: [
      {
        idDetailLkpKategoriInsiden: 0,
        kategoriInsidenId: 0,
        kategoriInsidenName: "",
        kategoriInsidenCode: "",
        detailKategoriInsidenId: 0,
        detailKategoriInsidenName: "",
        idKategoriHipo: 0,
        isCheked: true,
      },
    ],
    isReportAble: false,
    isWorkRelated: false,
    isRecordAble: false,

    //// Estimate Impact
    listDetailEstimateImpact: [
      {
        detailEstimateImpactId: 0,
        kode: "string",
        nama: "string",
        isByValue: true,
      },
    ],
    listDetailEstimateContent: [
      {
        idTblDataLkpEstimateImpact: 0,
        detailEstimateImpactId: 0,
        detailContentEstimateImpactId: 0,
        detailContentEstimateImpactName: "",
        estimateImpactContentItemId: 0,
        estimateImpactContentItemName: "string",
        detailContentValueEstimateImpactId: 0,
        idTipePekerja: 0,
        tipePekerja: "string",
        jumlahOrNilaiKerugian: 0,
        satuan: "",
        konversiSatuan: 0,
        nilaiKonversi: 0,
        tingkatKeparahan: 0,
        keterangan: "",
        isByValue: true,
      },
    ],
    potensiTingkatKeparahan: "",
    probabilitasKejadian: 0,

    //// Kemungkinan Penyebab
    kemungkinanPenyebabLangsung: "",
    kemungkinanPenyebabDasar: "",
    immadiateAction: "",
    uploadDocumentList: [
      {
        id: 0,
        idLkp: 0,
        url: "",
        fileZise: 0,
        isDelete: true,
      },
    ],
    pembuatDokumen: null,
    createdBy: null,
    modifiedBy: null,
    saveAs: "", // draft, submit
    staticValueBTR: 93000000,
    rejectedBy: null,
    RejectedDate: null,
    RejectedReason: null,
    listKepadas: [],
    listTembusan: [],
  });
  const [onLoad, setOnLoad] = useState(true);
  const [errorModal, setErrorModal] = useState({
    isOpen: false,
    message: "",
    validationErrMessage: [],
    listApprovalValidation: false,
  });
  const [loading, setLoading] = useState({
    fetch: false,
    submit: false,
    upload: false,
    searchIdamanUsers: false,
  });
  const history = useNavigate();
  const [dataUnit, setDataUnit] = useState([]);
  const [dataRegion, setDataRegion] = useState([]);
  const [dataLokasi, setDataLokasi] = useState([]);
  const [dataIdamanUser, setDataIdamanUser] = useState([]);
  const [isDisableSubmit, setIsDisableSubmit] = useState(true);
  const [reason, setReason] = useState("");

  // Fetch Form LKP Initial Value
  const [initialValue, setInitialValue] = useState(null);
  const [listEIC, setListEIC] = useState(null);
  const [EILoad, setEILoad] = useState(true);
  const [listDetailEstimateImpact, setListDetailEstimateImpact] =
    useState(null);
  const [isRejectedInfo, setIsRejectedInfo] = useState(false);

  useEffect(() => {
    const fetchInit = async () => {
      try {
        setLoading((prev) => ({ ...prev, fetch: true }));
        const resInit = await Promise.all([
          ApiService.getIncimanLkp(id),
          ApiService.getMsTipePekerjaan().then((res) => res.data.payload),
          ApiService.getMsUnit().then((res) => res.data.payload),
          ApiService.getMsRegional().then((res) => res.data.payload),
          ApiService.getIncimanLkp("MA==").then((res) => res.data.payload),
        ]);
        if (!resInit[0].data.isOk) throw resInit[0].data.message;
        const { payload } = resInit[0].data;
        setInputFields({
          ...payload,
          estimateImpactSelected: {
            title: new Array(6),
            type: new Array(2),
          },
          listTipePekerjaan: resInit[1],
          listApproval: payload.listApproval || [],
        });

        if (payload.rejectedBy && payload.rejectedDate) {
          setIsRejectedInfo(true);
        }
        setInitialValue(payload);
        setSelectedKategoriInsiden(
          payload.listAllKategoriInsiden.filter((item) => item.isCheked)
        );
        setDataUnit(resInit[2]);
        setDataRegion(resInit[3]);
        setUsedDetailEstimateContent(payload.listDetailEstimateContent);
        setListDetailEstimateImpact(resInit[4].listDetailEstimateImpact);
        setLoading((prev) => ({ ...prev, fetch: false }));
        setEILoad(false);
        setOnLoad(false);
      } catch (error) {
        setLoading((prev) => ({ ...prev, fetch: false }));
        setErrorModal({ isOpen: true, message: error });
        setEILoad(false);
        setOnLoad(false);
      }
    };
    fetchInit();
  }, []);

  useEffect(() => {
    if (!inputFields.idRegional) return;
    fetchDataLokasi(inputFields.idRegional);
  }, [inputFields.idRegional]);

  useEffect(() => {
    if (inputFields.forPrint) {
      handleOpenFullDialog();
    }
  }, [inputFields.forPrint]);

  const [resSave, setResSave] = useState(null);
  const [saveType, setSaveType] = useState("draft");

  const [open, setOpen] = useState(false);
  const handleOpen = (type) => {
    setSaveType(type);
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setSaveType("draft");
  };
  const handleSaveDraft = (type) => {
    setLoadDraft(true);
    setSaveType(type);
    handleSaveAs();
  };

  useEffect(() => {
    if (
      inputFields.idUnitBisnis &&
      inputFields.idRegional &&
      inputFields.documentPosition
    ) {
      setIsDisableSubmit(false);
    } else {
      setIsDisableSubmit(true);
    }
  }, [inputFields]);

  const handleSaveAs = async (type) => {
    //// TEST FINAL VALUE BEFORE POST
    // console.log("media.length", media.length);
    // let finalValue = {
    //   ...inputFields,
    //   tglKejadian:
    //     inputFields.tglKejadian.split("T")[0] +
    //     "T" +
    //     momentToDB(inputFields.waktuKejadian),
    //   waktuKejadian:
    //     inputFields.tglKejadian.split("T")[0] +
    //     "T" +
    //     momentToDB(inputFields.waktuKejadian),
    //   listAllKategoriInsiden: selectedKategoriInsiden,
    //   listDetailEstimateContent: usedDetailEstimateContent.current,
    //   saveAs: saveType,
    //   listDetailEstimateImpact: initialValue.listDetailEstimateImpact,
    //   isHipo: inputFields.isHipo === "true",
    // };
    // console.log("finalValue", finalValue);
    // return;

    // // SIngle file upload
    setLoadSave(true);
    console.log("saveType", saveType);

    try {
      // Jika user tidak mengganti file
      let finalValue = {
        ...inputFields,
        tglKejadian:
          momentDateToDB(inputFields.tglKejadian) +
          "T" +
          momentTimeToDB(inputFields.waktuKejadian),
        waktuKejadian:
          momentDateToDB(inputFields.tglKejadian) +
          "T" +
          momentTimeToDB(inputFields.waktuKejadian),
        listAllKategoriInsiden: selectedKategoriInsiden,
        isHipo:
          inputFields.isHipo === "true" || inputFields.isHipo === true
            ? true
            : false,
        saveAs: saveType,
        listDetailEstimateImpactContentItem: [],
        listDetailEstimateImpact: [],
        estimateImpactSelected: null,
        listTipePekerjaan: [],
      };

      console.log("finalValue", finalValue);
      let { listApproval } = inputFields;
      if (
        (saveType === "submit" &&
          inputFields.statusLkp?.toLowerCase() === "draft") ||
        (saveType === "draft" &&
          inputFields.statusLkp?.toLowerCase() === "draft")
      ) {
        if (
          !inputFields.listApproval ||
          inputFields.listApproval?.length === 0
        ) {
          console.log("request list approval to api");
          console.log("List_Approval>>>", inputFields.listApproval);

          const resValidate = await ApiService.validateLkp({
            regionId: finalValue.idRegional,
            documentPosition: finalValue.documentPosition,
          });
          listApproval = resValidate.data?.payload?.listApproval || [];
          setInputFields((prev) => ({ ...prev, listApproval }));
          //console.log("res>>>", resValidate);
          if (!resValidate.data.payload?.isCompleted) {
            // throw resValidate.data;
            setOpen(false);
            setSnackMessage("Lengkapi data reviewer");
            setSnackOpen(true);
            setLoadSave(false);
            setErrorModal((prev) => ({
              ...prev,
              listApprovalValidation: true,
            }));
            setSaveType("draft");
            return;
          }
        } else {
          // VALIDASI LIST REVIEWER
          console.log("validasi list approval, make sure emailnya diisi semua");
          console.log("List_Approval>>>", inputFields.listApproval);
          let isValid = true;
          inputFields.listApproval.some((val) => {
            if (!val?.emailUser) {
              isValid = false;
              return true;
            }
            return false;
          });

          if (!isValid) {
            setSnackMessage("Lengkapi data reviewer");
            setOpen(false);
            setSnackOpen(true);
            setLoadSave(false);
            setSaveType("draft");
            return;
          }
        }
      }

      const res = await ApiService.putIncimanLkp(finalValue.idLkp, {
        ...finalValue,
        listApproval: listApproval || [],
      });
      if (!res.data.isOk) {
        console.log("Data Req>>>", {
          ...finalValue,
          listApproval,
        });
        throw res.data;
      } else if (res.data.payload.noLkp) {
        setResSave(res.data.payload);
        setOpen(false);
        setOpen2(true);
      }

      setLoadDraft(false);
      setLoadSave(false);
    } catch (error) {
      console.log("Ini Errornya >>>", error);
      if (error.payload === undefined) {
        if (inputFields.statusLkp?.toLowerCase() === "draft") {
          setErrorModal({
            validationErrMessage: [error.message],
            listApprovalValidation:
              inputFields.listApproval.length > 0 ? true : false,
          });
        } else {
          setErrorModal({
            validationErrMessage: [error.message],
            listApprovalValidation: false,
          });
        }
      } else {
        if (inputFields.statusLkp?.toLowerCase() === "draft") {
          setErrorModal({
            validationErrMessage:
              error.payload === null
                ? [error.message]
                : error.payload.length > 0
                ? error.payload
                : [error.message],
            listApprovalValidation:
              inputFields.listApproval.length > 0 ? true : false,
          });
        } else {
          setErrorModal({
            validationErrMessage:
              error.payload === null
                ? [error.message]
                : error.payload.length > 0
                ? error.payload
                : [error.message],
            listApprovalValidation: false,
          });
        }
      }

      setOpen3(true);
      setOpen(false);
      setLoadDraft(false);
      setLoadSave(false);
    }
  };

  // listAllKategoriInsiden
  const [selectedKategoriInsiden, setSelectedKategoriInsiden] = useState([]);

  // listDetailEstimateContent
  const [usedDetailEstimateContent, setUsedDetailEstimateContent] = useState(
    []
  );

  const fetchTingkatKeparahanByValue = useCallback(
    debounce(
      async (
        { detailEstimateImpactId, value, totalFinancialImpactValue },
        callback
      ) => {
        const percentageBTR =
          inputFields.staticValueBTR == 0
            ? 0
            : Math.round(
                (totalFinancialImpactValue / inputFields.staticValueBTR) * 100
              );

        console.log(
          "percentageBTR >>" +
            (totalFinancialImpactValue / inputFields.staticValueBTR) * 100
        );

        const resSeverity = await Promise.all([
          ApiService.getTingkatKeparahanByValue({
            IdMstDetailEstimateImpact: detailEstimateImpactId,
            ContectValue: +value,
          }).then((res) => res.data.payload),
          ApiService.getTingkatKeparahanByValue({
            IdMstDetailEstimateImpact: 3, // Financial Impact
            ContectValue: percentageBTR,
          }).then((res) => res.data.payload),
        ]);

        callback(resSeverity);
      },
      300
    ),
    []
  );

  const checkPotensi = (list) => {
    console.log("List checkPotensi>>", list);
    let totalDeath = 0;
    let severity;
    list.forEach((dt) => {
      if (dt.kode === "DEAD") {
        totalDeath += Number(dt.jumlahOrNilaiKerugian);
      }
    });
    if (totalDeath > 1) {
      severity = 5;
    }
    // else if (totalDeath < 2) {
    //   severity = 4;
    // }
    else {
      severity = 4;
    }

    if (severity) {
      list = list.map((dt) => {
        if (dt.kode === "DEAD") {
          dt.tingkatKeparahan = severity;
        }
        return dt;
      });
    }

    if (!list) list = inputFields.listDetailEstimateContent;
    if (list.length < 1) {
      return {
        potensiTingkatKeparahan: null,
      };
    }
    const maxLevel = Math.max(...list.map((o) => o.tingkatKeparahan));
    if (maxLevel < 1 || maxLevel > 5) {
      return {
        potensiTingkatKeparahan: null,
      };
    }
    return {
      potensiTingkatKeparahan: potensiTingkatKeparahanItem.find(
        (o) => o.value == maxLevel
      ).name,
    };
  };

  const setIdamanUsers = useCallback(
    debounce(async (search) => {
      try {
        if (search?.trim() == "" || search?.trim().length < 5) return;
        setLoading((prev) => ({ ...prev, searchIdamanUsers: true }));

        const res = await ApiService.getIdamanUsers(search);
        if (!res.data.isOk) throw res.data;
        setDataIdamanUser(res.data.payload || []);
      } catch (error) {
        setSnackMessage(error.message);
        setSnackOpen(true);
      }
      setLoading((prev) => ({ ...prev, searchIdamanUsers: false }));
    }, 200)
  );

  // Dialog Save Berhasil
  const [open2, setOpen2] = useState(false);
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleDashboard = () => {
    navigate("/hsse/incident/dashboardlkp");
  };

  // Dialog Save Gagal
  const [open3, setOpen3] = useState(false);
  const handleClose3 = () => {
    setOpen3(false);
  };

  // Loading save
  const [loadSave, setLoadSave] = useState(false);
  const [loadDraft, setLoadDraft] = useState(false);

  // Snackbar
  const [snackOpen, setSnackOpen] = useState(false);
  const [snackMessage, setSnackMessage] = useState("");
  const closeSnack = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  };
  const openSnack = (message) => {
    setSnackMessage(message);
    setSnackOpen(true);
  };

  // Export Action
  const handleExport = () => {
    // const quality = 2; // Higher the better but larger file
    // html2canvas(document.querySelector("#page"), {
    //   scale: quality,
    // }).then((canvas) => {
    //   const imgData = canvas.toDataURL("image/png");
    //   const pdf = new jsPDF("p", "mm", "a4", true);
    //   const imgProps = pdf.getImageProperties(imgData);
    //   const pdfWidth = pdf.internal.pageSize.getWidth();
    //   const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
    //   pdf.addImage(imgData, "JPG", 0, 0, pdfWidth, pdfHeight);
    //   pdf.save(`${inputFields.noLkp}.pdf`);
    // });

    // html2canvas(document.querySelector("#page"), {
    //   scale: 2,
    //   logging: true,
    //   allowTaint: false,
    //   backgroundColor: null,
    // }).then((canvas) => {
    //   const imgWidth = 208;
    //   const pageHeight = 295;
    //   const imgHeight = (canvas.height * imgWidth) / canvas.width;
    //   let heightLeft = imgHeight;
    //   let position = 0;
    //   heightLeft -= pageHeight;
    //   const pdf = new jsPDF("p", "mm", "a4", true);
    //   pdf.addImage(canvas, "PNG", 0, position, imgWidth, imgHeight, "", "FAST");
    //   while (heightLeft >= 0) {
    //     position = heightLeft - imgHeight;
    //     pdf.addPage();
    //     pdf.addImage(
    //       canvas,
    //       "PNG",
    //       0,
    //       position,
    //       imgWidth,
    //       imgHeight,
    //       "",
    //       "FAST"
    //     );
    //     heightLeft -= pageHeight;
    //   }
    //   pdf.save(`${inputFields.noLkp}.pdf`);
    // });

    const element = document.getElementById("page");

    let opt = {
      margin: [30, 0, 30, 0],
      filename: `${inputFields.noLkp}.pdf`,
      image: { type: "jpeg", quality: 0.98 },
      html2canvas: {
        dpi: 96,
        scale: 3,
        scrollX: 0,
        scrollY: 0,
        backgroundColor: "#FFF",
      },
      jsPDF: { unit: "pt", format: "a4", orientation: "p" },
    };

    html2pdf()
      .set(opt)
      .from(element)
      .toPdf()
      .get("pdf")
      .then(function (pdf) {
        let totalPages = pdf.internal.getNumberOfPages();

        for (let i = 1; i <= totalPages; i++) {
          pdf.setPage(i);
          pdf.setFontSize(8);
          pdf.setTextColor(150);
          pdf.text(
            "Page " +
              i +
              " of " +
              totalPages +
              " *) Dokumen ini dibuat melalui aplikasi HIMS (HSSE Integrated Management System) dan dinyatakan valid tanpa tanda tangan.",
            pdf.internal.pageSize.getWidth() - 570,
            pdf.internal.pageSize.getHeight() - 10
          );
        }
      })
      .save();
  };

  const [fullDialog, setfullDialog] = useState(false);
  const handleCloseFullDialog = () => {
    setfullDialog(false);
  };
  const handleOpenFullDialog = () => {
    setfullDialog(true);
  };

  const fetchDataLokasi = async (id) => {
    const resLokasi = await ApiService.getMsLokasi(id).then(
      (res) => res.data.payload
    );
    setDataLokasi(resLokasi);
  };

  const handleReject = () => {
    const payload = {
      type: "reject",
      reason: reason,
    };

    ApiService.deleteOrRejectIncimanlkp(initialValue.idLkp, payload)
      .then((res) => {
        if (res.data.isOk) {
          history('/hsse/incident/dashboardlkp');
        } else if (!res.data.isOk) {
          throw res.data;
        }
      })
      .catch((err) => {
        setErrorModal({
          isOpen: true,
          message: err.message,
          listApprovalValidation: false,
        });
      });
  };

  const shouldDataBeReadOnly = () =>
    inputFields.statusLkp?.toLowerCase() === "issued" ||
    inputFields.statusLkp?.toLowerCase() === "completed";

  return (
    <div>
      <Container maxWidth={false}>
        <center>
          <h2>LAPORAN KEJADIAN PENTING</h2>
        </center>
        <Box component="form" noValidate autoComplete="off">
          {onLoad ? (
            <>
              <Skeleton width={"auto"} height={"312px"} animation="wave" />
            </>
          ) : (
            <HeaderUser
              inputFields={inputFields}
              setInputFields={setInputFields}
              dataUnit={dataUnit}
              dataRegion={dataRegion}
              dataLokasi={dataLokasi}
              readOnly={shouldDataBeReadOnly()}
              editVerified={
                inputFields.statusLkp?.toLowerCase() === "verified"
                  ? true
                  : false
              }
            />
          )}
          <br></br>

          {isRejectedInfo && (
            <Box component="div" sx={boxStyles}>
              <center>
                <h3
                  style={{
                    color: "black",
                  }}
                >
                  Rejected Info
                </h3>
                <Grid container spacing={0} justifyContent="flex-start">
                  <Grid
                    item
                    xs={2}
                    style={{ textAlign: "left", padding: "0px" }}
                  >
                    <h4>Rejected By</h4>
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    style={{ textAlign: "left", padding: "0px" }}
                  >
                    <h4>: {inputFields.rejectedBy}</h4>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    style={{ textAlign: "left", padding: "0px" }}
                  >
                    <h4>Alasan</h4>
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    style={{ textAlign: "left", padding: "0px" }}
                  >
                    <h4>: {inputFields.rejectedReason}</h4>
                  </Grid>
                  <Grid
                    item
                    xs={2}
                    style={{ textAlign: "left", padding: "0px" }}
                  >
                    <h4>Tanggal</h4>
                  </Grid>
                  <Grid
                    item
                    xs={10}
                    style={{ textAlign: "left", padding: "0px" }}
                  >
                    <h4>: {inputFields.rejectedDate}</h4>
                  </Grid>
                </Grid>
              </center>
            </Box>
          )}

          <br />

          {initialValue !== null &&
            initialValue.listAllKategoriInsiden !== undefined && (
              <InformasiKejadian
                selectedKategoriInsiden={selectedKategoriInsiden}
                setSelectedKategoriInsiden={setSelectedKategoriInsiden}
                setShowRecordable={setShowRecordable}
                inputFields={inputFields}
                setInputFields={setInputFields}
                listAllKategoriInsiden={initialValue.listAllKategoriInsiden}
                readOnly={shouldDataBeReadOnly()}
                enableOpenMap
                enableEditMap={false}
              />
            )}

          <br></br>

          <EstimateImpactRevamp
            input={inputFields}
            setInput={setInputFields}
            setSnackbar={({ message }) => openSnack(message)}
            checkPotensi={checkPotensi}
            fetchTingkatKeparahan={fetchTingkatKeparahanByValue}
            loading={loading.fetch}
            readOnly={shouldDataBeReadOnly()}
          />
          <br></br>

          <KemungkinanPenyebab
            inputFields={inputFields}
            setInputFields={setInputFields}
            readOnly={shouldDataBeReadOnly()}
            setSnackbar={({ message }) => openSnack(message)}
          />
        </Box>
        <br />

        <InformasiTembusan
          loading={loading.searchIdamanUsers}
          input={inputFields}
          setInput={setInputFields}
          dataIdamanUser={dataIdamanUser}
          setIdamanUsers={setIdamanUsers}
          setDataIdamanUser={setDataIdamanUser}
          openSnack={openSnack}
          readOnly={shouldDataBeReadOnly()}
        />

        {errorModal.listApprovalValidation ? (
          <ListReviewer
            loading={loading.searchIdamanUsers}
            input={inputFields}
            setInput={setInputFields}
            dataIdamanUser={dataIdamanUser}
            setIdamanUsers={setIdamanUsers}
            setDataIdamanUser={setDataIdamanUser}
          />
        ) : null}

        {inputFields.listApproval ? (
          inputFields.listApproval.length > 0 &&
          inputFields.statusLkp?.toLowerCase() !== "draft" ? (
            <ListApproval input={inputFields} />
          ) : (
            ""
          )
        ) : (
          ""
        )}

        <FooterReport
          loadDraft={loadDraft}
          handleSubmit={() => handleOpen("submit")}
          handleDraft={() => handleSaveDraft("draft")}
          status={inputFields.statusLkp?.toLowerCase()}
          handleExport={handleOpenFullDialog}
          readOnly={shouldDataBeReadOnly() || isDisableSubmit}
          createdDoc={inputFields.pembuatDokumen}
          newDoc={false}
          handleReject={inputFields.rejectedBy === null ? false : true}
          isRejectButton={inputFields && inputFields.statusLkp === "Verified"}
          handleRejectFunction={handleReject}
          setReason={setReason}
          reason={reason}
        />
      </Container>

      <Dialog
        fullScreen
        open={fullDialog}
        onClose={handleCloseFullDialog}
        TransitionComponent={Transition}
      >
        <AppBar sx={{ position: "relative" }}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleCloseFullDialog}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
              Export to PDF
            </Typography>
            <Button
              variant="contained"
              onClick={handleExport}
              startIcon={<FileDownloadIcon />}
              sx={{
                bgcolor: "white",
                color: "#1976d2",
                "&:hover": {
                  bgColor: "#1976d2",
                  color: "white",
                },
              }}
            >
              Print
            </Button>
          </Toolbar>
        </AppBar>
        <LKPToPDF id={id} />
      </Dialog>

      {/* Snackbar / Alert */}
      <SnackbarCustom
        duration={3000}
        type={"warning"}
        open={snackOpen}
        onClose={closeSnack}
        message={snackMessage}
      />

      {/* Dialog Konfirmasi Save */}
      <DialogCustom
        open={open}
        handleClose={handleClose}
        title={
          <>
            Notifikasi
            {handleClose ? (
              <IconButton
                aria-label="close"
                onClick={handleClose}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={
          <>
            Apakah anda yakin akan {saveType.toUpperCase()} dokument ini? <br />
            Pastikan data sudah terisi dengan lengkap dan benar
          </>
        }
        actions={
          <>
            <Button
              onClick={handleClose}
              variant="outlined"
              disabled={loadSave}
            >
              Batal
            </Button>
            <LoadingButton
              onClick={handleSaveAs}
              autoFocus
              variant="contained"
              loading={loadSave}
              startIcon={<SaveIcon />}
              loadingPosition="start"
            >
              {!loadSave ? "Ya," : ""} {saveType.toUpperCase()}
            </LoadingButton>
          </>
        }
      />

      {/* Dialog Save Berhasil */}
      {resSave !== null && (
        <DialogCustom
          open={open2}
          handleClose={handleClose2}
          title={
            <>
              Notifikasi
              {handleClose2 ? (
                <IconButton
                  aria-label="close"
                  onClick={handleClose2}
                  sx={{
                    position: "absolute",
                    right: 8,
                    top: 8,
                    color: (theme) => theme.palette.grey[500],
                  }}
                >
                  <CloseIcon />
                </IconButton>
              ) : null}
            </>
          }
          content={
            <>
              Berhasil Membuat LKP No {resSave.noLkp} <br />
              Dengan Status {resSave.statusLkp}
            </>
          }
          actions={
            <>
              <Button onClick={handleDashboard} autoFocus variant="contained">
                Kembali ke Dashboard
              </Button>
            </>
          }
        />
      )}

      {/* Dialog Save GAGAL */}
      <DialogCustom
        open={open3}
        handleClose={handleClose3}
        title={
          <>
            Notifikasi
            {handleClose3 ? (
              <IconButton
                aria-label="close"
                onClick={handleClose3}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: (theme) => theme.palette.grey[500],
                }}
              >
                <CloseIcon />
              </IconButton>
            ) : null}
          </>
        }
        content={
          errorModal.validationErrMessage ? (
            <>
              {errorModal.validationErrMessage.map((item, idx) => (
                <p key={idx} style={{ margin: 0, padding: 0 }}>
                  {item}
                </p>
              ))}
            </>
          ) : (
            <>
              LKP Gagal Dibuat! <br />
              Silahkan periksa kembali data yang telah didinputkan.
            </>
          )
        }
        actions={
          <>
            <Button onClick={handleClose3} autoFocus variant="contained">
              Tutup
            </Button>
          </>
        }
      />
      <DialogCustom
        open={errorModal.isOpen}
        handleClose={() =>
          setErrorModal((prev) => ({ ...prev, isOpen: false }))
        }
        title={
          <>
            Terjadi Kesalahan
            <IconButton
              aria-label="close"
              onClick={() =>
                setErrorModal((prev) => ({ ...prev, isOpen: false }))
              }
              sx={{
                position: "absolute",
                right: 8,
                top: 8,
                color: (theme) => theme.palette.grey[500],
              }}
            >
              <CloseIcon />
            </IconButton>
          </>
        }
        content={<p style={{ minWidth: 200 }}>{errorModal.message}</p>}
        actions={
          <>
            <Button
              onClick={() => navigate("/hsse/incident/dashboardlkp")}
              autoFocus
              variant="contained"
            >
              Kembali
            </Button>
          </>
        }
      />
    </div>
  );
};

export default EditLKP;
